"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ = require("../../..");

var _theme = _interopRequireDefault(require("../../../theme/theme.styles"));

var _atoms = require("../../atoms");

var _InputSelect = require("./InputSelect.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var InputSelect = function InputSelect(_ref) {
  var _emptyMessage$cta, _emptyMessage$cta2;

  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'secondary' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'full' : _ref$size,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'occ-input-select' : _ref$dataTestId,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data,
      _ref$onSelect = _ref.onSelect,
      onSelect = _ref$onSelect === void 0 ? function (rowData) {
    return console.log(rowData);
  } : _ref$onSelect,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function (data) {
    return console.log(data);
  } : _ref$onChange,
      emptyMessage = _ref.emptyMessage,
      _ref$disableFiltering = _ref.disableFiltering,
      disableFiltering = _ref$disableFiltering === void 0 ? false : _ref$disableFiltering,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      elementsFiltered = _useState2[0],
      setElementsFiltered = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = _slicedToArray(_useState3, 2),
      inputValue = _useState4[0],
      setInputValue = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      time = _useState6[0],
      setTime = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      searching = _useState8[0],
      setSearching = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isOpen = _useState10[0],
      setIsOpen = _useState10[1];

  function removeAccents(str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  function filter(val) {
    if (!val) return;
    var temp;

    if (!disableFiltering) {
      temp = data.filter(function (_ref2) {
        var label = _ref2.label;
        return removeAccents(label).toLowerCase().includes(removeAccents(val).toLowerCase());
      });
      setElementsFiltered(temp);
    } else setElementsFiltered(data);

    setSearching(false);
    setIsOpen(true);
  }

  function filterWithTime(val) {
    setSearching(true);
    if (time !== null) clearTimeout(time);
    var id = setTimeout(function () {
      return filter(val);
    }, 200);
    setTime(id);
  }

  var handleInputChange = function handleInputChange(_ref3) {
    var value = _ref3.target.value;

    if (!value) {
      if (time !== null) {
        setSearching(false);
        clearTimeout(time);
      }

      setElementsFiltered([]);
    } else {
      filterWithTime(value);
      onChange && onChange(value);
    }

    setInputValue(value);
  };

  var handleSelect = function handleSelect(rowData) {
    setInputValue(rowData.label);
    onSelect(rowData.value);
  };

  var closeList = function closeList() {
    setTimeout(function () {
      setIsOpen(false);
    }, 100);
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_theme["default"], null), /*#__PURE__*/_react["default"].createElement(_InputSelect.Occ_InputSelect, {
    "data-test-id": dataTestId
  }, /*#__PURE__*/_react["default"].createElement(_.Input, {
    color: color,
    label: label,
    size: size,
    type: "text",
    updateValue: true,
    value: inputValue,
    action: handleInputChange,
    onBlur: closeList,
    onFocus: function onFocus() {
      return setIsOpen(true);
    },
    disabled: disabled
  }), /*#__PURE__*/_react["default"].createElement(_InputSelect.Occ_InputSelect_options, null, searching && /*#__PURE__*/_react["default"].createElement(_InputSelect.Occ_InputSelect_row, null, /*#__PURE__*/_react["default"].createElement(_.Paragraph, {
    align: "center",
    color: color
  }, ' ', "Buscando resultados...")), !searching && isOpen && inputValue.length > 0 && !elementsFiltered.length && /*#__PURE__*/_react["default"].createElement(_.Column, {
    alignment: "center"
  }, /*#__PURE__*/_react["default"].createElement(_InputSelect.EmptyMessage_Container, null, emptyMessage ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_.Paragraph, {
    align: "center",
    color: "muted",
    weight: "bold"
  }, emptyMessage.title), /*#__PURE__*/_react["default"].createElement(_.Spacer, {
    value: "8px",
    direction: "vertical"
  }), /*#__PURE__*/_react["default"].createElement(_.Paragraph, {
    align: "center",
    color: "muted",
    weight: "normal",
    size: "xxs"
  }, emptyMessage.subtitle), /*#__PURE__*/_react["default"].createElement(_.Spacer, {
    value: "8px",
    direction: "vertical"
  }), /*#__PURE__*/_react["default"].createElement(_atoms.Button, {
    type: "text",
    size: "full",
    action: (_emptyMessage$cta = emptyMessage.cta) === null || _emptyMessage$cta === void 0 ? void 0 : _emptyMessage$cta.action
  }, (_emptyMessage$cta2 = emptyMessage.cta) === null || _emptyMessage$cta2 === void 0 ? void 0 : _emptyMessage$cta2.text)) : /*#__PURE__*/_react["default"].createElement(_.Paragraph, {
    align: "center",
    color: color
  }, ' ', "No se encontraron resultados."))), !searching && isOpen && inputValue && elementsFiltered.length > 0 && elementsFiltered.map(function (rowData, i) {
    return rowData.label && /*#__PURE__*/_react["default"].createElement(_InputSelect.Occ_InputSelect_row, {
      onBlur: function onBlur() {
        return setIsOpen(false);
      },
      onFocus: function onFocus() {
        return setIsOpen(true);
      },
      key: '_' + i,
      onClick: function onClick() {
        return handleSelect(rowData);
      }
    }, /*#__PURE__*/_react["default"].createElement(_.Paragraph, {
      align: "center",
      color: color
    }, ' ', rowData.label));
  }), !searching && isOpen && !inputValue && !elementsFiltered.length && data.length > 0 && data.map(function (rowData, i) {
    return rowData.label && /*#__PURE__*/_react["default"].createElement(_InputSelect.Occ_InputSelect_row, {
      onBlur: function onBlur() {
        return setIsOpen(false);
      },
      onFocus: function onFocus() {
        return setIsOpen(true);
      },
      key: '_' + i,
      onClick: function onClick() {
        return handleSelect(rowData);
      }
    }, /*#__PURE__*/_react["default"].createElement(_.Paragraph, {
      align: "center",
      color: color
    }, ' ', rowData.label));
  }))));
};

var _default = InputSelect;
exports["default"] = _default;